module.exports = __webpack_public_path__ + "img/skolahald.78349f37.svg";